import * as entity from '@common/domain/entities/RequisitionItem'
import * as app from '@framework/app';
import { appSettings } from '../../../modules/shared/components/appSettings';
import { AppSettings } from 'src/app/entities/AppSettings';
import { IDataEndPoint, IFieldOptions, IEntityEndPoints } from '@framework/interfaces/IEntity';
import { IApiServiceCommand } from '@services/api/api.service';
import { ViewType, FieldType, WorkflowType } from '../../../framework/core/Enums';
import { CustomControlStockItemAutoCompleteComponent } from '../../../modules/requisition/components/custom-control-stock-item-auto-complete/custom-control-stock-item-auto-complete.component';
import { FormBuilderControlListHelper } from '../../formbuilder/FormBuilderControlListHelper';
import { Permissions } from '../../../config/AppEnums';
import { IDetailComponent } from '../../../framework/components/mf-blade/mf-blade.component';

import * as _ from 'underscore';
import { IEntityModel } from '../../../framework/interfaces/IEntityModel';
import { RequisitionItemDTO } from '../../domain/models/RequisitionItemDTO';
import { RequisitionPartialDTO } from '../../domain/models/RequisitionPartialDTO';
import { SupplierDTO } from '../../domain/models/SupplierDTO';
import { StockItemDTO } from '../../domain/models/StockItemDTO';
import { extend } from 'webdriver-js-extender';
import { ActionDialogComponent } from '../../../modules/shared/components/action-dialog/action-dialog.component';
export class RequisitionItemEndPoints extends entity.RequisitionItemEndPoints {
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/perRequisition/" + serviceCommand.context.entityId }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/perRequisitionCount/" + serviceCommand.context.entityId }, method: "POST" };
  get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/detail/" + serviceCommand.context.entityId }, method: "GET" };
  update?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/updateDetail/" + serviceCommand.context.entityId }, method: "POST" };
}

export class PartialRequisitionItemEndPoints extends entity.RequisitionItemEndPoints {
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/perPartial/" + serviceCommand.context.entityId }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/perPartial/" + serviceCommand.context.entityId }, method: "POST" };
  get?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/RequisitionPartial/detail/" + serviceCommand.context.entityId }, method: "GET" };
}

export class RequisitionItemMyListEndPoints extends entity.RequisitionItemEndPoints {
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/processedItems/" + serviceCommand.context.entityId }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/processedItemsCount/" + serviceCommand.context.entityId }, method: "POST" };
}


export class RequisitionTaxableItemEndPoints extends entity.RequisitionItemEndPoints {
  insert?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/requisitionItem/setTaxable",
    //url: app.config.controllerRouteRoot + "/user/addOrganisation?userId={context.parent.parent.selectedItem.id}&organisationId={data.id}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        userId: serviceCommand.context.entityId,
        reqItemId: serviceCommand.data.id
      }
    },
    method: "POST"
  };

  delete?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/requisitionItem/setNonTaxable",
    //url: app.config.controllerRouteRoot + "/user/addOrganisation?userId={context.parent.parent.selectedItem.id}&organisationId={data.id}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        userId: serviceCommand.context.entityId,
        reqItemId: serviceCommand.data.id
      }
    },
    method: "POST"
  };
}

export class RequisitionInStockItemEndPoints extends entity.RequisitionItemEndPoints {
  insert?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/requisitionItem/setInStock",
    //url: app.config.controllerRouteRoot + "/user/addOrganisation?userId={context.parent.parent.selectedItem.id}&organisationId={data.id}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        userId: serviceCommand.context.entityId,
        reqItemId: serviceCommand.data.id
      }
    },
    method: "POST"
  };

  delete?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/requisitionItem/setNotInStock",
    //url: app.config.controllerRouteRoot + "/user/addOrganisation?userId={context.parent.parent.selectedItem.id}&organisationId={data.id}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        userId: serviceCommand.context.entityId,
        reqItemId: serviceCommand.data.id
      }
    },
    method: "POST"
  };
}

export class SendForProcessingEndPoints extends entity.RequisitionItemEndPoints {
  update?: IDataEndPoint = {
    url: app.config.controllerRouteRoot + "/requisitionItem/updateItemProcess",
    //url: app.config.controllerRouteRoot + "/user/addOrganisation?userId={context.parent.parent.selectedItem.id}&organisationId={data.id}",
    params: function (serviceCommand: IApiServiceCommand): object {
      return {
        userId: serviceCommand.context.entityId,
        reqItemId: serviceCommand.data.id,
        sendForProcessing: serviceCommand.data.sendForProcessing
      }
    },
    method: "POST"
  };
}



export class RequisitionItemDetailedReportListBladeSetup {
  public menuActions: Array<IDetailComponent> = [
    {
      index: 0, displayName: "Export Selected", click: function (context) {
        var table = context.getFormInstanceByIndex(0).lazyTable;
        let filterArr = new Array();


        if (table.staticFilters)
          table.staticFilters.filter(function (o) {
            return o.filterValue != '' && o.filterValue != null
          })
            .forEach(o => {
              filterArr.push({ columnName: o.columnName, filterValue: o.filterValue, whereFilterType: o.whereFilterType });
            });
        let filterObject = JSON.parse(table._currentFilterObject);
        filterObject.StartCount = 0;
        filterObject.PageSize = 9999999;
        filterObject.FriendlyCols = table.selectedVisibleColumns.map(o => ({ value: o.dbField, key: o.name }))

        var download: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/lazyExport" }, method: "POST" };
        var self = context;


        self.apiService.exec({
          data: filterObject,
          endPoint: download,
          context: self,
          success: function (data) {
            const link = document.createElement('a');
            link.href = `${appSettings.apiServiceAddress}/api/fileServe/report/${data.name}`;
            link.setAttribute('visibility', 'hidden');
            link.click();
          },
          error: function (error) {
            self.loading = false;
            self.messageService.danger('Could not Export', 'Action');
          }
        })
      }
    },
  ]
}

export class RequisitionItemReportListBladeSetup {
  public menuActions: Array<IDetailComponent> = [
    {
      index: 0, displayName: "Export Selected", click: function (context) {
        var table = context.getFormInstanceByIndex(0).lazyTable;
        let filterArr = new Array();


        if (table.staticFilters)
          table.staticFilters.filter(function (o) {
            return o.filterValue != '' && o.filterValue != null
          })
            .forEach(o => {
              filterArr.push({ columnName: o.columnName, filterValue: o.filterValue, whereFilterType: o.whereFilterType });
            });
        let filterObject = JSON.parse(table._currentFilterObject);
        filterObject.StartCount = 0;
        filterObject.PageSize = 9999999;
        filterObject.FriendlyCols = table.selectedVisibleColumns.map(o => ({ value: o.dbField, key: o.name }))

        var download: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/lazyExport" }, method: "POST" };
        var self = context;


        self.apiService.exec({
          data: filterObject,
          endPoint: download,
          context: self,
          success: function (data) {
            const link = document.createElement('a');
            link.href = `${appSettings.apiServiceAddress}/api/fileServe/report/${data.name}`;
            link.setAttribute('visibility', 'hidden');
            link.click();
          },
          error: function (error) {
            self.loading = false;
            self.messageService.danger('Could not Export', 'Action');
          }
        })
      }
    },
  ]
}
export class RequisitionItemBladeSetup {
  public onSaveEvent = function (prop) {
    if (prop.listIndex == 0) {
      prop.parent.parent.getBladeByIndex(0).reloadFormByIndex(0);
      prop.parent.parent.getBladeByIndex(1).reloadFormByIndex(1);
      if (prop.entityId == "00000000-0000-0000-0000-000000000000")
        prop.parent.parent.getBladeByIndex(2).closeBlade();
      prop.parent.parent.getBladeByIndex(1).reloadFormByIndex(3);
    }
  }


  public onFormLoad: Function = function (data: any, formIndex?: any, context?: any) {
    var self = this;
    var isReadonly = false;
    if (formIndex == 0) {
      if (context.authService.userProfile) {
        if (context.entityData.requisition.latestWorkflow && context.entityData.requisition.latestWorkflow.workflowType != WorkflowType.WorkflowRequisitionCreated
          && context.entityData.requisition.latestWorkflow.workflowType != WorkflowType.WorkflowRejectedForCorrection
        ) {
          if (context.entityData.requisition.latestWorkflow.workflowType == WorkflowType.WorkflowProcurementOfficer || context.entityData.requisition.latestWorkflow.workflowType == WorkflowType.WorkflowRejectedForCorrectionOfficer) {
            if (!context.authService.hasAnyPermissions(Permissions.ProcurementApproval)) {
              isReadonly = true;//context.makeFormReadOnly(true);
            }
            else isReadonly = false;//context.makeFormReadOnly(false);
          }
          else isReadonly = true;//context.makeFormReadOnly(true);
        } else if (context.entityData.requisition.createdByUserId == context.authService.userProfile.sub || context.entityData.requisition.linkedUserId == context.authService.userProfile.sub)
          isReadonly = false;//context.makeFormReadOnly(false);
        else isReadonly = true;//context.makeFormReadOnly(true);
        if (context.authService.hasAnyPermissions(Permissions.ProcurementAdmin))
          isReadonly = false;
        context.makeFormReadOnly(isReadonly);
      }
      else {
        context.authService.userProfileObserver.subscribe(o => {
          if (context.entityData.requisition.latestWorkflow && (context.entityData.requisition.latestWorkflow.workflowType != WorkflowType.WorkflowRequisitionCreated
            && context.entityData.requisition.latestWorkflow.workflowType != WorkflowType.WorkflowRejectedForCorrection)) {
            if (context.entityData.requisition.latestWorkflow.workflowType == WorkflowType.WorkflowProcurementOfficer || context.entityData.requisition.latestWorkflow.workflowType == WorkflowType.WorkflowRejectedForCorrectionOfficer) {
              if (!context.authService.hasAnyPermissions(Permissions.ProcurementApproval)) {
                isReadonly = true;//context.makeFormReadOnly(true);
              }
              else isReadonly = false;//context.makeFormReadOnly(false);
            }
            else isReadonly = true;//context.makeFormReadOnly(true);
          } else if (context.entityData.requisition.createdByUserId == context.authService.userProfile.sub || context.entityData.requisition.linkedUserId == context.authService.userProfile.sub)
            isReadonly = false;//context.makeFormReadOnly(false);
          else isReadonly = true;//context.makeFormReadOnly(true);
          if (context.authService.hasAnyPermissions(Permissions.ProcurementAdmin))
            isReadonly = false;
          context.makeFormReadOnly(isReadonly);
        });
      }
    }
  }

  protected getPanelHeaderFunc = function (context) {
    var form = context.getFormInstanceByIndex(0);
    if (!form || !context.getFormInstanceByIndex(0).entityData || !context.getFormInstanceByIndex(0).entityData.nonStandardItemDescription)
      return '';
    return context.getFormInstanceByIndex(0).entityData.nonStandardItemDescription + ' @ R ' + context.getFormInstanceByIndex(0).entityData.price;
  }
  public getPanelSubtitleFunc = function (context) {
    var form = context.getFormInstanceByIndex(0);
    if (!form || !context.getFormInstanceByIndex(0).entityData || !context.getFormInstanceByIndex(0).entityData.latestWorkflow || !context.getFormInstanceByIndex(0).entityData.latestWorkflow.workflow)
      return '';
    return 'Current Status: ' + context.getFormInstanceByIndex(0).entityData.latestWorkflow.workflow.name;
  }

  public onMenuActionOverlayClick = function (context) {
    context.loading = true;
    context.showActionDialog = false;

    if (context.overlayPanelData.text) {
      context.getFormInstanceByIndex(0).entityData.sivNumber = context.overlayPanelData.text;

      context.overlayIsSmallText = false;
      context.apiService.post(`/api/requisitionItem/setSIV`, null, { params: { reqItemId: context.entityId, sivNumber: context.overlayPanelData.text } })
        .subscribe(o => {
          context.loading = false;
          context.messageService.success('Save successfully', 'Action');
          context.parent.getBladeByIndex(0).reloadFormByIndex(0);
          context.parent.getBladeByIndex(1).reloadFormByIndex(1);
          context.reloadFormByIndex(0);
          context.reloadFormByIndex(2);
          if (context.overlayPanelData && context.overlayPanelData.doNotCloseBlade) {

          }
          else context.closeBlade();
        }, err => {
          context.loading = false;
          context.messageService.danger('Could not save', 'Action');
        })

    }
    else {
      context.apiService.post(`/api/requisitionItem/createWorkflow/${context.overlayPanelIdentifier}/${context.entityId}`, { comments: context.overlayPanelData.comments })
        .subscribe(o => {
          context.loading = false;
          context.messageService.success('Save successfully', 'Action');
          context.parent.getBladeByIndex(0).reloadFormByIndex(0);
          context.parent.getBladeByIndex(1).reloadFormByIndex(1);
          context.reloadFormByIndex(0);
          context.reloadFormByIndex(2);
          if (context.overlayPanelData && context.overlayPanelData.doNotCloseBlade) {

          }
          else context.closeBlade();
        }, err => {
          context.loading = false;
          context.messageService.danger('Could not save', 'Action');
        })
    }
  }
  public menuActions: Array<IDetailComponent> = [
    {
      index: 0, displayName: "Add note", click: function (context, event) {
        context.overlayPanelData = { doNotCloseBlade: true };
        context.overlayPanelIdentifier = context.getFormInstanceByIndex(0).entityData.latestWorkflow.workflowType;
        context.panelHeader = "Add note";
        context.showActionDialog = true;
      }, isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        if (formTriggerIndex == 0) {
          if (context.entityData.requisition.latestWorkflow && context.entityData.requisition.latestWorkflow.workflowType != WorkflowType.WorkflowRequisitionCreated) {
            if (!context.authService.hasAnyPermissions(Permissions.RequisitionApproval, Permissions.ProcurementApproval, Permissions.StockRequisition)) {
              return true;
            }
          }
          return false;
        }
        return;
      }, icon: "fas fa-sticky-note"
    },
    {
      index: 0, displayName: "Set SIV #", click: function (context, event) {
        context.overlayPanelData = { text: context.getFormInstanceByIndex(0).entityData.sivNumber };
        context.overlayIsSmallText = true;
        context.panelHeader = "Set SIV #";
        context.showActionDialog = true;

      }, isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        if (formTriggerIndex == 0) {
          if (context.entityData.partial && context.entityData.partial.latestWorkflow.workflowType == WorkflowType.WorkflowPartialIssuedToWarehouse) {
            if (context.authService.hasAnyPermissions(Permissions.StockRequisition)) {
              if (context.authService.hasAnyPermissions(Permissions.ProcurementAdmin))
                return false;
              if (context.entityData.requisition.warehouseUserIds.indexOf(context.authService.userProfile.sub) != -1)
                return false;
              return true;
            }
          }
          return true;
        }
        return;
      }
    },
    //{
    //  index: 1, displayName: "Complete", click: function (context, event) {
    //    context.overlayPanelData = {};
    //    context.overlayPanelIdentifier = WorkflowType.WorkflowItemProcessed;
    //    context.panelHeader = "Complete";
    //    context.showActionDialog = true;
    //  }, isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
    //    if (newItem)
    //      return true;
    //    if (formTriggerIndex == 0) {
    //      if (context.entityData.partial && context.entityData.partial.latestWorkflow.workflowType == WorkflowType.WorkflowPartialIssuedToWarehouse) {
    //        if (context.authService.hasAnyPermissions(Permissions.StockRequisition)) {
    //          return false;
    //        }
    //      }
    //      return true;
    //    }
    //    return;
    //  }, icon: "fas fa-paper-plane"
    //},

    //{
    //  index: 1, displayName: "Item is Out of Stock", click: function (context, event) {
    //    context.getFormInstanceByIndex(0).entityData.inStock = true;
    //    context.getFormInstanceByIndex(0).entityData.auditComments = "In stock updated";
    //    context.getFormInstanceByIndex(0).save(true);
    //  }, isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
    //    if (newItem)
    //      return true;
    //    if (formTriggerIndex == 0) {
    //      if (entityData.requisition.latestWorkflow.workflowType == WorkflowType.WorkflowProcurementOfficer) {
    //        if (context.authService.hasAnyPermissions(Permissions.ProcurementApproval)) {
    //          if (!entityData.inStock)
    //            return false;
    //        }
    //      }
    //      return true;
    //    }
    //    return;
    //  }, icon: "fas fa-times"
    //},
    //{
    //  index: 1, displayName: "Item is In Stock", click: function (context, event) {
    //    context.getFormInstanceByIndex(0).entityData.inStock = false;
    //    context.getFormInstanceByIndex(0).entityData.auditComments = "In stock updated";
    //    context.getFormInstanceByIndex(0).save(true);
    //  }, isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
    //    if (newItem)
    //      return true;
    //    if (formTriggerIndex == 0) {
    //      if (entityData.requisition.latestWorkflow.workflowType == WorkflowType.WorkflowProcurementOfficer) {
    //        if (context.authService.hasAnyPermissions(Permissions.ProcurementApproval))
    //          if (entityData.inStock)
    //            return false;
    //      }
    //      return true;
    //    }
    //    return;
    //  }, icon: "fas fa-check"
    //},
    {
      index: 1, displayName: "Mark for Approval", click: function (context, event) {
        context.overlayPanelData = {};
        context.overlayPanelIdentifier = WorkflowType.WorkflowItemApprovalRequested;
        context.panelHeader = "Mark for Approval";
        context.showActionDialog = true;
      }, isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        if (formTriggerIndex == 0) {
          if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowItemPending) {
            if (context.authService.hasAnyPermissions(Permissions.ProcurementApproval))
              return false;
          }
          return true;
        }
        return;
      }, icon: "fas fa-paper-plane"
    },
    {
      index: 1, displayName: "Unmark for Approval", click: function (context, event) {
        context.overlayPanelData = {};
        context.overlayPanelIdentifier = WorkflowType.WorkflowItemPending;
        context.panelHeader = "Unmark for Approval";
        context.showActionDialog = true;
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        if (formTriggerIndex == 0) {
          if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowItemApprovalRequested) {
            if (context.authService.hasAnyPermissions(Permissions.ProcurementApproval))
              return false;
          }
          return true;
        }
        return;
      }, icon: "fas fa-times"
    },
    {
      index: 1, displayName: "Decline for correction", click: function (context, event) {
        context.overlayPanelData = {};
        context.overlayPanelIdentifier = WorkflowType.WorkflowItemDeclined;
        context.panelHeader = "Decline for correction";
        context.showActionDialog = true;
      },
      isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        if (formTriggerIndex == 0) {
          if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowItemApprovalRequested) {
            if (context.authService.hasAnyPermissions(Permissions.ProcurementApproval))
              return false;
          }
          return true;
        }
        return;
      }, icon: "fas fa-reply"
    },
    {
      index: 2, displayName: "Approve", click: function (context, event) {
        context.overlayPanelData = {};
        context.overlayPanelIdentifier = WorkflowType.WorkflowItemApproved;
        context.panelHeader = "Approve";
        context.showActionDialog = true;
      }, isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        if (formTriggerIndex == 0) {


          if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowItemApprovalRequested) {
            if (context.authService.hasAnyPermissions(Permissions.RequisitionApproval))
              return false;
          }
          return true;
        }
        return;
      }, icon: "fas fa-check-double"
    },
    {
      index: 2, displayName: "Unapprove", click: function (context, event) {
        context.overlayPanelData = {};
        context.overlayPanelIdentifier = WorkflowType.WorkflowItemApprovalRequested;
        context.panelHeader = "Unapprove";
        context.showActionDialog = true;
      }, isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        if (formTriggerIndex == 0) {
          if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowItemApproved) {
            if (context.authService.hasAnyPermissions(Permissions.RequisitionApproval))
              return false;
          }
          return true;
        }
        return;
      }, icon: "fas fa-times"
    },
    {
      index: 3, displayName: "Reject for correction", click: function (context, event) {
        context.overlayPanelData = {};
        context.overlayPanelIdentifier = WorkflowType.WorkflowItemRejectedForCorrectionOfficer;
        context.panelHeader = "Reject for correction";
        context.showActionDialog = true;
      }, isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        if (formTriggerIndex == 0) {
          if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowItemApprovalRequested) {
            if (context.authService.hasAnyPermissions(Permissions.RequisitionApproval))
              return false;
          }
          return true;
        }
        return;
      }, icon: "fas fa-reply"
    },
    {
      index: 4, displayName: "Reject permanently", click: function (context, event) {
        context.overlayPanelData = {};
        context.overlayPanelIdentifier = WorkflowType.WorkflowItemPermanentDeclined;
        context.panelHeader = "Reject permanently";
        context.showActionDialog = true;
      }, isMenuHidden: function (context, entityId, newItem, formTriggerIndex, entityData) {
        if (newItem)
          return true;
        if (formTriggerIndex == 0) {
          if (entityData.latestWorkflow.workflowType == WorkflowType.WorkflowItemApprovalRequested) {
            if (context.authService.hasAnyPermissions(Permissions.RequisitionApproval))
              return false;
          }
          return true;
        }
        return;
      }, icon: "fas fa-times"
    }


  ]
}

export class RequisitionItemFormFields extends entity.RequisitionItemFormFields {
  public hideStore: Function = function (entity, auth, context) {
    if (entity.requisition)
      return entity.requisition.isStore;
    else {
      return context.parent.parent.getBladeByIndex(1).getFormInstanceByIndex(0).entityData.isStore;
    }
  }

  public hidePettyCash: Function = function (entity, auth, context) {
    if (entity.requisition)
      return entity.requisition.isPettyCash;
    else {
      return context.parent.parent.getBladeByIndex(1).getFormInstanceByIndex(0).entityData.isPettyCash;
      ;
    }
  }
  private invoiceCheck: any;
  private currentInvoiceNo: any;
  constructor() {
    super();
    try {
      if (this["id"]) this.splice(this.indexOf(this["id"]), 1)
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.splice(0, this.length)
      let minOrderQuantity: IFieldOptions = {
        field: "minOrderQuantity", fieldType: FieldType.String, viewType: ViewType.String, name: "Minimum Order Quantity", readOnly: true, show: function (data) {
          return data.minOrderQuantity && data.minOrderQuantity != '';
        }
      }
      let packagingQuantity: IFieldOptions = {
        field: "packagingQuantity", fieldType: FieldType.String, viewType: ViewType.String, name: "Packaging Quantity", readOnly: true, show: function (data) {
          return data.packagingQuantity && data.packagingQuantity != '';
        }
      }
      let unitOfMeasureDescription: IFieldOptions = {
        field: "uom", fieldType: FieldType.String, viewType: ViewType.String, name: "Unit of measure", readOnly: false,
        dataEndPoint: { url: app.config.controllerRouteRoot + "/UnitOfMeasure/dropdown" }, dataDisplayField: 'name', dataIdField:'id'
        //show: function (data) {
        //  return data.unitOfMeasureDescription && data.unitOfMeasureDescription != '';
        //}
      }
      
      unitOfMeasureDescription.change = function (o, n, entity, context) {
        if (n && n.length > 10)
          entity.uom = n.substring(0, 10);
      }
      let supplierIdAutoComplete: IFieldOptions = { field: "supplierId" };
      supplierIdAutoComplete.name = "Supplier";
      supplierIdAutoComplete.viewType = ViewType.AutoComplete;
      supplierIdAutoComplete.dataEndPoint = { url: app.config.controllerRouteRoot + "/Supplier/detail/" };
      supplierIdAutoComplete.searchEndPoint = { url: app.config.controllerRouteRoot + "/Supplier/searchAuto/" };
      supplierIdAutoComplete.dataDisplayField = "name";
      supplierIdAutoComplete.dataIdField = "id";
      supplierIdAutoComplete.show = function (entity, auth, context) {
        if (!auth)
          return false;

        if (entity.inStock)
          return false;
        if (typeof entity.isStandardItem != 'undefined' && !entity.isStandardItem && !entity.inStock || entity.standardItemSupplierNotLinked)
          return true;
        return (typeof entity.isStandardItem != 'undefined' && !entity.isStandardItem && !entity.inStock && auth.hasAnyPermissions(Permissions.ProcurementApproval, Permissions.RequisitionApproval)) || entity.standardItemSupplierNotLinked
      }
      let standardItemSupplierNotLinked: IFieldOptions = {
        field: "standardItemSupplierNotLinked", fieldType: FieldType.String, viewType: ViewType.YesNo, name: "Show all Suppliers", show: function (entity, auth) {
          if (!auth)
            return false;

          if (entity.inStock)
            return false;
          return typeof entity.isStandardItem != 'undefined' && entity.isStandardItem && auth.hasAnyPermissions(Permissions.ProcurementApproval, Permissions.RequisitionApproval, Permissions.ReqViewAllSuppliersOnStockItem);
        }
      }
      this.sivNumber.readOnly = true;
      this.sivNumber.show = function (data) {
        return data.sivNumber && data.sivNumber != '';
      }

      this.sisProLineNum.readOnly = true;
      this.sisProLineNum.show = function (data) {
        return data.sisProLineNum && data.sisProLineNum != '';
      }
      this.sysproError.readOnly = true;
      this.sysproError.show = function (data) {
        return data.sysproError && data.sysproError != '';
      }
      this.sysproImportedFlag.readOnly = true;
      this.sysproImportedFlag.show = function (data) {
        return data.sysproImportedFlag && data.sysproImportedFlag != '';
      }

      this.sysproPo.readOnly = true;
      this.sysproPo.show = function (data) {
        return data.sysproPo && data.sysproPo != '';
      }
      this.sysproReceivedQty.readOnly = true;
      this.sysproReceivedQty.show = function (data) {

        return data.sysproReceivedQty && data.sysproReceivedQty != '';
      }
      this.sysproOrderCompleted.readOnly = true;
      this.sysproOrderCompleted.show = function (data) {
        return data.sysproOrderCompleted && data.sysproOrderCompleted != '';
      }
      this.sivRequired.viewType = ViewType.YesNo;
      this.sivRequired.show = function (entity, auth) {
        if (!auth)
          return false;
        return auth.hasAnyPermissions(Permissions.ProcurementApproval, Permissions.ProcurementAdmin);
      };

      this.push(this.sivNumber);
      this.push(this.inStock);
      this.push(this.warehouseId);
      this.push(this.dueDate);
      this.dueDate.placeHolder = "Select a due date";
      this.push(this.jobSpecific);
      this.push(this.projectJobNumberId);
      this.push(this.generalLedgerId);
      this.push(this.taxable);
      this.push(this.sivRequired);

      this.push(this.invoiceNo);
      this.push(this.isStandardItem);
      this.isStandardItem.name = "Catalog featured item";
      this.projectJobNumberId.placeHolder = "Select a job";
      this.generalLedgerId.placeHolder = "Select a General Ledger"
      this.hierarchyId.placeHolder = "Select a hierarchy";
      this.warehouseId.placeHolder = "Select a warehouse";
      this.supplierId.placeHolder = "Select a supplier";
      this.push(this.stockItemId);
      this.variant.name = "Item variant (If applicable)"
      this.variant.placeHolder = "Paint color for example";
      this.variant.show = function (entity) {
        return typeof entity.isStandardItem != 'undefined' && entity.isStandardItem && entity.stockItemId
      }
      this.push(this.variant);
      this.push(this.nonStandardItemDescription)
      this.push(standardItemSupplierNotLinked);
      this.push(supplierIdAutoComplete)
      this.push(this.supplierId)
      this.push(unitOfMeasureDescription);
      this.push(packagingQuantity);
      this.push(minOrderQuantity);

      this.push(this.unitPrice);
      this.push(this.qty);
      this.push(this.discountPrice);
      this.push(this.price);
      this.push(this.hierarchyId);

      this.push(this.sisProLineNum);
      this.push(this.sysproError);
      this.push(this.sysproImportedFlag);
      this.push(this.sysproPo);
      this.push(this.sysproReceivedQty);
      this.push(this.sysproOrderCompleted);
      this.warehouseId.name = "Stock Warehouse";
      this.warehouseId.viewType = ViewType.Dropdown;
      this.warehouseId.searchEndPoint = { url: app.config.controllerRouteRoot + "/warehouse/smartAutocomplete" };
      this.warehouseId.dataEndPoint = { url: app.config.controllerRouteRoot + "/warehouse/dropdown" };
      this.warehouseId.dataDisplayField = "name";
      this.warehouseId.dataIdField = "id";
      this.warehouseId.required = true;
      this.warehouseId.show = function (entity, auth) {
        if (!entity)
          return
        if (entity.inStock)
          return true;
        else return false;
      }
      this.inStock.show = function (entity, auth, context) {
        if (_th.hideStore(entity, auth, context))
          return false;
        if (!auth)
          return;
        return auth.hasAnyPermissions(Permissions.ProcurementApproval, Permissions.RequisitionApproval);
      };

      this.dueDate.required = true;
      this.jobSpecific.required = true;
      this.jobSpecific.show = function (entity, auth, context) {
        return !_th.hideStore(entity, auth, context)

      }
      this.generalLedgerId.show = function (entity, auth, context) {
        return !_th.hideStore(entity, auth, context)
      }
      this.projectJobNumberId.required = true;
      this.generalLedgerId.required = true;
      this.hierarchyId.required = function (entity, auth, context) {
        return !entity.generalLedgerId && !entity.hierarchyId
      };
      this.taxable.required = true;
      this.isStandardItem.required = true;
      this.stockItemId.required = true;
      this.nonStandardItemDescription.required = true;
      supplierIdAutoComplete.required = function (entity, auth) {
        if (!auth)
          return false;
        return auth.hasAnyPermissions(Permissions.ProcurementApproval, Permissions.RequisitionApproval);
      };
      this.supplierId.required = true;

      this.isStandardItem.change = function (o, n, entity, context) {
        if (entity && entity.isStandardItem == false && entity.prevSupplierId)
          entity.supplierId = entity.prevSupplierId;
      }

      this.qty.required = true;
      this.qty.name = "Quantity";
      this.qty.change = function (o, n, entity, context) {
        _th.qty.validationMessage = '';
        if (entity.minOrderQuantity) {
          if (parseInt(entity.qty) < parseInt(entity.minOrderQuantity)) {
            _th.qty.validationMessage = `Quantity does not meet minimum order quantity (${entity.minOrderQuantity}) for the item`
          }
        }
        if (entity.packagingQuantity) {
          if (parseInt(entity.qty) % parseInt(entity.packagingQuantity) > 0) {
            _th.qty.validationMessage = `Quantity does not fit packaging quantity (${entity.packagingQuantity}) for the item`
          }
        }

        if (entity.qty < 0)
          _th.qty.validationMessage = `Cannot have negative quantity`
        if (entity.unitPrice && entity.qty)
          entity.price = (((entity.unitPrice * (entity.discountPrice ? (1 - (parseFloat(entity.discountPrice) / 100)) : 1))) * entity.qty);

      }
      this.qty.show = function (entity, auth, context) {
        if (_th.hidePettyCash(entity, auth, context))
          return false;
        return typeof entity.isStandardItem != 'undefined';
      }
      this.unitPrice.change = function (o, n, entity, context) {
        _th.unitPrice.validationMessage = '';
        if (entity.unitPrice < 0)
          _th.unitPrice.validationMessage = `Cannot have negative unit price`
        if (entity.unitPrice && entity.qty)
          entity.price = (((entity.unitPrice * (entity.discountPrice ? (1 - (parseFloat(entity.discountPrice) / 100)) : 1))) * entity.qty);
      }
      this.unitPrice.required = function (entity, auth) {
        if (!auth)
          return false;
        return auth.hasAnyPermissions(Permissions.ProcurementApproval, Permissions.RequisitionApproval);
      };
      this.unitPrice.viewType = ViewType.Currency;
      this.unitPrice.settings = { prefix: 'R' };
      this.unitPrice.show = function (entity, auth) {
        if (!auth || typeof entity.isStandardItem == 'undefined')
          return false;
        return ((entity.isStandardItem) || !entity.isStandardItem)
      }

      let auditComments: IFieldOptions = { field: "auditComments", name: "Change comments", viewType: ViewType.Text, fieldType: FieldType.String };
      auditComments.show = function (entity, auth, context) {
        if (!auth)
          return false;
        if (_th.hideStore(entity, auth, context))
          return false;
        return auth.hasAnyPermissions(Permissions.ProcurementApproval, Permissions.RequisitionApproval) && !entity.inStock
      }
      auditComments.required = true;
      this.push(auditComments)


      this.hierarchyId.show = function (entity, auth, context) {
        if (_th.hideStore(entity, auth, context))
          return false;
        if (_th.hidePettyCash(entity, auth, context))
          return false;
        if (!auth)
          return false;
        if (entity.generalLedgerId)
          return false;
        return auth.hasAnyPermissions(Permissions.ProcurementApproval, Permissions.RequisitionApproval)
      }

      this.discountPrice.viewType = ViewType.Float;
      //this.discountPrice = { prefix: '%' };
      // this.discountPrice.default = '0';
      this.discountPrice.show = function (entity, auth, context) {
        if (!auth || typeof entity.isStandardItem == 'undefined')
          return false;
        return true;
      }
      this.discountPrice.change = function (o, n, entity, context) {
        if (entity.unitPrice && entity.qty)
          entity.price = (((entity.unitPrice * (entity.discountPrice ? (1 - (parseFloat(entity.discountPrice) / 100)) : 1))) * entity.qty);

        if (entity.discountPrice && parseFloat(entity.discountPrice) > 100 || parseFloat(entity.discountPrice) < 0)
          _th.discountPrice.validationMessage = `Only values between 0% - 100% are allowed`
        else
          _th.discountPrice.validationMessage = null;
      }
      unitOfMeasureDescription.show = function (entity, auth, context) {
        if (!auth || typeof entity.isStandardItem == 'undefined')
          return false;
        return true;
      }

      this.price.name = "Total Price (Calculated)";
      this.price.viewType = ViewType.Currency;
      this.price.settings = { prefix: 'R' };
      this.price.readOnly = true;
      this.price.show = function (entity, auth, context) {
        if (!auth || typeof entity.isStandardItem == 'undefined')
          return false;
        if (_th.hidePettyCash(entity, auth, context))
          return false;
        return ((entity.isStandardItem) || !entity.isStandardItem)
      }
      //this.price.required = function (entity, auth) {
      //  if (!auth)
      //    return false;
      //  return auth.hasAnyPermissions(Permissions.ProcurementApproval, Permissions.RequisitionApproval);
      //};
      this.dueDate.required = true;
      this.stockItemId.show = function (entity) {
        return typeof entity.isStandardItem != 'undefined' && entity.isStandardItem
      }
      this.stockItemId.field = "stockItemId";
      this.stockItemId.viewType = ViewType.CustomControl;
      this.stockItemId.customControl = CustomControlStockItemAutoCompleteComponent;
      this.stockItemId.name = "Catalog Item";

      this.nonStandardItemDescription.show = function (entity) {
        return typeof entity.isStandardItem != 'undefined' && !entity.isStandardItem
      }

      this.nonStandardItemDescription.name = "Item Description";
      this.supplierId.name = "Supplier";
      this.supplierId.viewType = ViewType.Dropdown;
      this.supplierId.dataDisplayField = "name";
      this.supplierId.dataIdField = "id";
      this.supplierId.show = function (entity, auth, context) {
        if (!auth)
          return false;
        if (entity.inStock)
          return false;
        return typeof entity.isStandardItem != 'undefined' && entity.isStandardItem && auth.hasAnyPermissions(Permissions.ProcurementApproval, Permissions.RequisitionApproval, Permissions.ReqViewAllSuppliersOnStockItem) && !entity.standardItemSupplierNotLinked && !_th.hidePettyCash(entity, auth, context);
      }

      this.dueDate.viewType = ViewType.Date;
      this.generalLedgerId.viewType = ViewType.AutoComplete;
      this.generalLedgerId.dataEndPoint = { url: app.config.controllerRouteRoot + "/GeneralLedger/detail/" };
      this.generalLedgerId.searchEndPoint = { url: app.config.controllerRouteRoot + "/GeneralLedger/search/" };
      this.generalLedgerId.dataDisplayField = "code";
      this.generalLedgerId.dataIdField = "id";


      this.hierarchyId.viewType = ViewType.Dropdown;
      this.hierarchyId.dataEndPoint = { url: app.config.controllerRouteRoot + "/hierarchy/dropdown" };
      this.hierarchyId.dataDisplayField = "code";
      this.hierarchyId.dataIdField = "id";

      this.inStock.viewType = ViewType.YesNo;
      this.isStandardItem.viewType = ViewType.YesNo;
      this.isStandardItem.show = function (entityData, auth, context) {
        //if (_th.hideStore(entity, auth, context))
        //return false;
        if (_th.hidePettyCash(entityData, auth, context))
          return false;
        return true;
      }
      this.taxable.viewType = ViewType.YesNo;
      this.jobSpecific.viewType = ViewType.YesNo;
      this.jobSpecific.change = function (o, n, entity, context) {
        if (entity.jobSpecific)
          entity.generalLedgerId = null;
        else entity.projectJobNumberId = null;
      }

      this.projectJobNumberId.show = function (entity) {
        return typeof entity.jobSpecific != 'undefined' && entity.jobSpecific;
      }
      this.generalLedgerId.show = function (entity) {
        return typeof entity.jobSpecific != 'undefined' && !entity.jobSpecific;
      }
      this.projectJobNumberId.name = "Job";
      this.projectJobNumberId.viewType = ViewType.Dropdown;
      this.projectJobNumberId.dataEndPoint = { url: app.config.controllerRouteRoot + "/projectJobNumber/dropdown" };
      this.projectJobNumberId.dataDisplayField = "sysproJobNo";
      this.projectJobNumberId.dataIdField = "id";

      var _th = this;
      this.stockItemId.change = function (o, n, entity, context) {
        var n = entity;
        if (n && n.stockItemSuppliers && n.stockItemSuppliers.length > 0) {
          //_th.stockItemId =  n.stockItemSuppliers[0].stockItem.id

          _th.supplierId.lookups = n.stockItemSuppliers.map(i => {
            return {
              label: i.supplier.name + ' @ R' + i.price, value: i.supplier.id
            }
          });
          if (_th.supplierId.formBuilderControl) {
            _th.supplierId.formBuilderControl.lookups = _th.supplierId.lookups;
          }
          entity.minOrderQuantity = n.stockItemSuppliers[0].stockItem.minOrderQuantity;
          entity.packagingQuantity = n.stockItemSuppliers[0].stockItem.packagingQuantity;
          entity.unitOfMeasureDescription = n.stockItemSuppliers[0].stockItem.unitOfMeasureDescription && n.stockItemSuppliers[0].stockItem.unitOfMeasureDescription != '' ? n.stockItemSuppliers[0].stockItem.unitOfMeasureDescription : 'EA';
          entity.uom = n.stockItemSuppliers[0].stockItem.unitOfMeasureDescription;
          if (!entity.uom) {
            debugger;
            entity.uom = 'EA'
          }

          if (context.parent && context.parent.parent) {
            var supplierFormField = context.parent.parent.formFields.filter(function (o) {
              return o.bindingValue == "supplierId" && o.controlType.viewType == ViewType.Dropdown
            });
            if (supplierFormField.length > 0) {

              supplierFormField[0].lookups = new Array();
              supplierFormField[0].lookups = n.stockItemSuppliers.map(i => {
                return {
                  label: i.supplier.name + ' @ R' + i.price, value: i.supplier.id
                }
              });
              if (supplierFormField[0].refreshLookups)
                supplierFormField[0].refreshLookups();
              //if (context.parent.setFilteredLookups) {
              //  debugger;
              // context.parent.setFilteredLookups();
              //}
              //context.parent.parent.formFields[context.parent.parent.formFields.indexOf(supplierFormField[0])].lookups = _th.supplierId.lookups
            }
          }



          if (!n.stockItemSuppliers[0].initial) {
            if (n.stockItemSuppliers[0].stockItem.generalLedgerId)
              entity.generalLedgerId = n.stockItemSuppliers[0].stockItem.generalLedgerId;
            if (n.stockItemSuppliers[0].stockItem.hierarchyId)
              entity.hierarchyId = n.stockItemSuppliers[0].stockItem.hierarchyId;
            if (!entity.standardItemSupplierNotLinked)
              entity.supplierId = n.stockItemSuppliers[0].supplier.id;
            entity.unitPrice = n.stockItemSuppliers[0].price;
            entity.price = (((entity.unitPrice * (entity.discountPrice ? (1 - (parseFloat(entity.discountPrice) / 100)) : 1))) * entity.qty);
          }
          entity.nonStandardItemDescription = n.stockItemSuppliers[0].stockItem.description;
          if (entity.qty) {
            _th.qty.validationMessage = '';
            if (entity.minOrderQuantity) {
              if (parseInt(entity.qty) < parseInt(entity.minOrderQuantity)) {
                _th.qty.validationMessage = `Quantity does not meet minimum order quantity (${entity.minOrderQuantity}) for the item`
              }
            }
            if (entity.packagingQuantity) {
              if (parseInt(entity.qty) % parseInt(entity.packagingQuantity) > 0) {
                _th.qty.validationMessage = `Quantity does not fit packaging quantity (${entity.packagingQuantity}) for the item`
              }
            }
          }

          //  if (context.parent && context.parent.parent && context.parent.parent.cdr)
          //  context.parent.parent.cdr.detectChanges();

          //if (context.parent.cdr) {
          //  context.parent.checkChanges();
          //  context.parent.cdr.markForCheck();
          //  context.parent.cdr.detectChanges();
          //}

        }
        else {
          if (context.parent && context.parent.parent) {
            var supplierFormField = context.parent.parent.formFields.filter(function (o) {
              return o.bindingValue == "supplierId" && o.controlType.viewType == ViewType.Dropdown
            });
            if (supplierFormField.length > 0) {

              supplierFormField[0].lookups = new Array();
              entity.standardItemSupplierNotLinked = true;

              entity.nonStandardItemDescription = n.description;
              if (entity.qty) {
                _th.qty.validationMessage = '';
                if (entity.minOrderQuantity) {
                  if (parseInt(entity.qty) < parseInt(entity.minOrderQuantity)) {
                    _th.qty.validationMessage = `Quantity does not meet minimum order quantity (${entity.minOrderQuantity}) for the item`
                  }
                }
                if (entity.packagingQuantity) {
                  if (parseInt(entity.qty) % parseInt(entity.packagingQuantity) > 0) {
                    _th.qty.validationMessage = `Quantity does not fit packaging quantity (${entity.packagingQuantity}) for the item`
                  }
                }
              }

              if (!entity.uom) {
                entity.uom = 'EA'
              }

              // entity.supplierId = null;
              if (supplierFormField[0].refreshLookups)
                supplierFormField[0].refreshLookups();
              //if (context.parent.setFilteredLookups) {
              //  debugger;
              // context.parent.setFilteredLookups();
              //}
              //context.parent.parent.formFields[context.parent.parent.formFields.indexOf(supplierFormField[0])].lookups = _th.supplierId.lookups
            }
          }
        }
      }
      var self = this;
      this.invoiceNo.change = function (o, n, entity, context) {
        var invoiceNo = context.data;
        self.currentInvoiceNo = invoiceNo;
        if (typeof invoiceNo != 'undefined' && invoiceNo != '') {
          if (self.invoiceCheck)
            clearTimeout(self.invoiceCheck);
          self.invoiceCheck = setTimeout(() => {
            context.apiService.post(`/api/requisition/validateInvoiceNo/${entity.requisitionId}`, { invoiceNo: self.currentInvoiceNo })
              .subscribe(o => {
                console.log(o);
                if (!o.valid) {
                  context.dialogService.open(ActionDialogComponent, {
                    data: {
                      buttonActions: [
                        {
                          iconClass: "", tooltip: "", text: "Ok", click: function (ref) {
                            ref.close();
                          }
                        }
                      ],
                      message: o.message,
                    },
                    header: `Duplicate Invoice number`,
                    width: '450px'
                  });
                }
              }, err => {

              })
          }, 3000)
        }
      }

    } catch { }
  }


}

export class RequisitionItemForm extends entity.RequisitionItemForm {
  protected requisitionItemFormEndPoints: RequisitionItemEndPoints = new RequisitionItemEndPoints();
  protected requisitionItemFormFields: RequisitionItemFormFields = new RequisitionItemFormFields();

  public onLoaded: Function = function (context: any, entity?: any) {
    if (context.entityId == "00000000-0000-0000-0000-000000000000") {
      context.entityData.requisitionId = context.parent.previousEntityId;
      context.entityData.taxable = true;
      context.entityData.qty = 1;
      context.entityData.uom = 'EA';
      context.entityData.unitOfMeasureDescription = 'EA';
      context.entityData.discountPrice = 0;
      if (context.parent.parent.getBladeByIndex(1).getFormInstanceByIndex(0).entityData.isPettyCash) {

        context.entityData.isStandardItem = false;
      }
      if (context.parent.parent.getBladeByIndex(1).getFormInstanceByIndex(0).entityData.isStore) {

        context.entityData.isStandardItem = true;
      }
      var prevItems = context.parent.parent.getBladeByIndex(1).getFormInstanceByIndex(1).items;
      if (prevItems && prevItems.data && prevItems.data.length > 0) {
        var sorted = _.sortBy(prevItems.data, 'datestamp');
        var prevItem = sorted[sorted.length - 1];
        context.entityData.jobSpecific = prevItem.jobSpecific;
        context.entityData.jobId = prevItem.jobId;
        context.entityData.projectJobNumberId = prevItem.projectJobNumberId;
        context.entityData.dueDate = prevItem.dueDate;
        context.entityData.prevSupplierId = prevItem.supplierId;
        if (context.parent.parent.getBladeByIndex(1).getFormInstanceByIndex(0).entityData.isPettyCash)
          context.entityData.supplierId = prevItem.supplierId
      }
    } else {
      //if (context.entityData.requisition.latestWorkflow && context.entityData.requisition.latestWorkflow.workflowType != WorkflowType.WorkflowRequisitionCreated ) {
      //  if (!context.authService.hasAnyPermissions(Permissions.ProcurementApproval)) {
      //    context.makeFormReadOnly(true);
      //  }
      //}
      //else if (context.entityData.requisition.latestWorkflow && (context.entityData.requisition.latestWorkflow.workflowType == WorkflowType.WorkflowRequisitionCreated || context.entityData.requisition.latestWorkflow.workflowType == WorkflowType.WorkflowRejectedForCorrection) && (context.entityData.requisition.createdByUserId == context.authService.userProfile.sub  || context.entityData.requisition.linkedUserId == context.authService.userProfile.sub)) {

      //  context.makeFormReadOnly(false);
      //}
      //else context.makeFormReadOnly(true);
    }
    var unitPrice = context.formFields.filter(o => o.field == "unitPrice");
    if (context.parent.parent.getBladeByIndex(1).getFormInstanceByIndex(0).entityData.isPettyCash) {
      if (unitPrice.length > 0)
        unitPrice[0].displayName = "Amount Paid";
    }
    else {
      if (unitPrice.length > 0)
        unitPrice[0].displayName = "Unit Price";
    }
  }
  public canDelete?: boolean = true;
}

export class RequisitionItemListColumns extends entity.RequisitionItemListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.splice(0, this.length);
      this.nonStandardItemDescription.name = "Item Description";
      this.projectJobNumberId.visible = false;
      this.datestamp.visible = false;
      this.jobSpecific.visible = false;
      this.push(this.datestamp);
      this.push(this.projectJobNumberId);
      this.push(this.jobSpecific);
      this.push(this.hierarchyId);
      this.hierarchyId.visible = false;
      this.push(this.generalLedgerId);
      this.push(this.warehouseId);
      this.warehouseId.visible = false;
      this.generalLedgerId.visible = false;
      var sendForProcessing = FormBuilderControlListHelper.getListColumn("requisition", "Process item", ViewType.StatusChange, null, "sendForProcessing");
      sendForProcessing.readOnly = false;
      sendForProcessing.canClick = function (context, data) {
        if (context.extraData &&
          (context.extraData.latestWorkflowRequisitionWorkflowType == WorkflowType.WorkflowApprovalRequested && context.authService.hasAnyPermissions(Permissions.RequisitionApproval))
          || ((context.extraData.latestWorkflowRequisitionWorkflowType == WorkflowType.WorkflowProcurementOfficer || context.extraData.latestWorkflowRequisitionWorkflowType == WorkflowType.WorkflowRejectedForCorrectionOfficer)
            && context.authService.hasAnyPermissions(Permissions.ProcurementApproval))
        )
          return true;
        return false;
      }
      sendForProcessing.endPoints = new SendForProcessingEndPoints();
      sendForProcessing.width = 100;
      this.push(sendForProcessing);
      this.push(FormBuilderControlListHelper.getListColumn("latestRequisitionItemWorkflow.workflow.name", "Workflow", null, null, "latestRequisitionItemWorkflow_workflow_name"));


      var workflowId = FormBuilderControlListHelper.getListColumn("latestRequisitionItemWorkflow.workflowId", "Workflow", null, null, "latestRequisitionItemWorkflow_workflowId");
      workflowId.visible = false;
      this.push(workflowId);
      this.isStandardItem.readOnly = false;
      this.inStock.viewType = ViewType.CheckBox;
      this.inStock.readOnly = function (data, auth) {
        if (!auth || !data)
          return true;
        //if (_th.hidePettyCash(entity, auth, context))
        //  return false;
        //data.requisition.latestWorkflow.workflowType == WorkflowType.WorkflowProcurementOfficer && 
        //return !((data.latestWorkflowRequisitionWorkflowType == WorkflowType.WorkflowProcurementOfficer || data.latestWorkflowRequisitionWorkflowType == WorkflowType.WorkflowRejectedForCorrectionOfficer) && auth.hasAnyPermissions(Permissions.RequisitionApproval))
        return true;
      };
      this.inStock.endPoints = new RequisitionInStockItemEndPoints();
      //this.inStock.visible = false;
      //// this.push(this.isStandardItem);
      this.push(this.inStock);
      var dueDate = FormBuilderControlListHelper.getListColumn("dueDate", "Due Date", null, null, "dueDate_formatted")
      this.push(dueDate);

      this.push(this.nonStandardItemDescription)
      this.push(this.qty);
      this.push(this.unitPrice);
      this.unitPrice.template = function (t) {
        return typeof t == 'undefined' ? '' : "R " + t.toLocaleString()
      }
      this.push(FormBuilderControlListHelper.getListColumn("price", "Price", null, null, "price_formatted"));
      var supplier = FormBuilderControlListHelper.getListColumn("supplier.name", "Supplier", null, null, "supplier_name_formatted");
      var warehouse = FormBuilderControlListHelper.getListColumn("warehouse.name", "Supplier", null, null, "supplier_name_formatted");
      warehouse.visible = false;
      this.push(warehouse);
      supplier.width = 100;
      this.qty.width = 70;
      this.inStock.width = 70;
      //supplier.visible = false;
      this.push(this.id)

      this.taxable.readOnly = false;
      this.taxable.endPoints = new RequisitionTaxableItemEndPoints();
      this.push(this.taxable);
      this.push(this.supplierId);
      this.supplierId.visible = false;
      var job = FormBuilderControlListHelper.getListColumn("projectJobNumber.sysproJobNo", "Job", null, null, "projectJobNumber_sysproJobNo");
      var ledger = FormBuilderControlListHelper.getListColumn("generalLedger.code", "Ledger", null, null, "generalLedger_code");
      job.width = 70;
      ledger.width = 70;
      this.push(job);
      this.push(ledger);
      this.taxable.width = 70;
      dueDate.width = 100;


      var validationsPassed = FormBuilderControlListHelper.getListColumn("id", "Valid", ViewType.YesNoIcon, null, "validationPassed");
      validationsPassed.readOnly = false;
      validationsPassed.width = 60;
      this.unshift(validationsPassed);

      this.push(supplier);
      this.isStandardItem.name = "Standard Item";

      this.forEach(o => {
        if (typeof o.width == "undefined")
          o.width = 100;
      })
    } catch { }
  }
}


export class RequisitionMyItemListColumns extends entity.RequisitionItemListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.splice(0, this.length);
      this.nonStandardItemDescription.name = "Item Description";
      this.projectJobNumberId.visible = false;
      this.datestamp.visible = false;
      this.jobSpecific.visible = false;
      this.push(this.datestamp);
      this.push(this.projectJobNumberId);
      this.push(this.jobSpecific);
      this.push(this.hierarchyId);
      this.hierarchyId.visible = false;
      this.push(this.generalLedgerId);
      this.push(this.warehouseId);
      this.warehouseId.visible = false;
      this.generalLedgerId.visible = false;

      this.push(FormBuilderControlListHelper.getListColumn("requisitionPartial.latestRequisitionPartialWorkflow.workflow.name", "Workflow", null, null, "requisitionPartial_latestRequisitionPartialWorkflow_workflow_name"));

      var po = FormBuilderControlListHelper.getListColumn("requisitionPartial.sisproIdentifier", "PO #", null, null, "requisitionPartial_sisproIdentifier");
      po.template = function (val, data) { return `${data.requisitionPartial_sisproIdentifierPrefix}${data.requisitionPartial_sisproIdentifier}` }
      po.visible = false;
      this.unshift(po);
      var poPrefix = FormBuilderControlListHelper.getListColumn("requisitionPartial.sisproIdentifierPrefix", "PO #", null, null, "requisitionPartial_sisproIdentifierPrefix");
      this.unshift(poPrefix);
      var workflowId = FormBuilderControlListHelper.getListColumn("latestRequisitionItemWorkflow.workflowId", "Workflow", null, null, "latestRequisitionItemWorkflow_workflowId");
      workflowId.visible = false;
      this.push(workflowId);
      this.isStandardItem.readOnly = false;



      this.push(this.qty);
      this.push(this.nonStandardItemDescription)

      var supplier = FormBuilderControlListHelper.getListColumn("supplier.name", "Supplier", null, null, "supplier_name_formatted");
      var warehouse = FormBuilderControlListHelper.getListColumn("warehouse.name", "Supplier", null, null, "supplier_name_formatted");
      warehouse.visible = false;
      this.push(warehouse);
      supplier.width = 1;
      this.qty.width = 70;
      this.inStock.width = 70;
      //supplier.visible = false;
      this.push(this.id)

      this.push(this.supplierId);
      this.supplierId.visible = false;
      this.push(supplier);
      var job = FormBuilderControlListHelper.getListColumn("projectJobNumber.sysproJobNo", "Job", null, null, "projectJobNumber_sysproJobNo");
      var ledger = FormBuilderControlListHelper.getListColumn("generalLedger.code", "Ledger", null, null, "generalLedger_code");
      job.width = 70;
      ledger.width = 70;
      this.push(job);
      this.push(ledger);


      this.isStandardItem.name = "Standard Item";


    } catch { }
  }
}

export class RequisitionItemReportListColumns extends entity.RequisitionItemListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.splice(0, this.length);
      this.push(FormBuilderControlListHelper.getListColumn("requisition.uniqueId", "SIMA Identifier", null, null, "requisition_uniqueId"))
      this.push(FormBuilderControlListHelper.getListColumn("buyerUser.SisproPrefix", "Buyer", null, null, "buyerUser_SisproPrefix"))
      this.push(FormBuilderControlListHelper.getListColumn("projectJobNumber.sysproJobNo", "MJob", null, null, "projectJobNumber_sysproJobNo"))
      this.push(FormBuilderControlListHelper.getListColumn("generalLedger.code", "MGlCode", null, null, "generalLedger_code"))
      this.push(FormBuilderControlListHelper.getListColumn("supplier.code", "Supplier", null, null, "supplier_code"))
      this.push(FormBuilderControlListHelper.getListColumn("supplier.name", "SupplierName", null, null, "supplier_name_formatted"))
      this.push(FormBuilderControlListHelper.getListColumn("stockItem.code", "MStockCode", null, null, "stockItem_code"))
      this.push(FormBuilderControlListHelper.getListColumn("nonStandardItemDescription", "MStockDes", null, null, "nonStandardItemDescription"))
      //this.push(FormBuilderControlListHelper.getListColumn("supplier.code", "MOrderUom", null, null, "mOrderUom"))
      this.push(FormBuilderControlListHelper.getListColumn("requisitionPartial.sisproIdentifierFormatted", "MRequisition", null, null, "requisitionPartial_sisproIdentifierFormatted"))
      this.push(FormBuilderControlListHelper.getListColumn("sisProLineNum", "MRequisitionLine", null, null, "sisProLineNum"))
      this.push(FormBuilderControlListHelper.getListColumn("qty", "MOrderQty", null, null, "qty"))
      this.push(FormBuilderControlListHelper.getListColumn("sysproReceivedQty", "MReceivedQty", null, null, "sysproReceivedQty"))
      this.push(FormBuilderControlListHelper.getListColumn("supplier.code", "Outstanding Qty", null, null, "outstandingQty"))
      //this.push(FormBuilderControlListHelper.getListColumn("supplier.code", "Branch", null, null, "branch"))
      //this.splice(0, this.length);
      //this.nonStandardItemDescription.name = "Item Description";
      //this.projectJobNumberId.visible = false;
      //this.datestamp.visible = false;
      //this.jobSpecific.visible = false;
      //this.push(this.datestamp);
      //this.push(this.projectJobNumberId);
      //this.push(this.jobSpecific);
      //this.push(FormBuilderControlListHelper.getListColumn("latestRequisitionItemWorkflow.workflow.name", "Workflow", null, null, "latestRequisitionItemWorkflow_workflow_name"));
      //var workflowId = FormBuilderControlListHelper.getListColumn("latestRequisitionItemWorkflow.workflowId", "Workflow", null, null, "latestRequisitionItemWorkflow_workflowId");
      //workflowId.visible = false;
      //this.push(workflowId);
      //this.isStandardItem.readOnly = false;
      //this.inStock.visible = false;
      ////// this.push(this.isStandardItem);
      //this.push(this.inStock);
      //this.push(FormBuilderControlListHelper.getListColumn("dueDate", "Due Date", null, null, "dueDate_formatted"));
      //this.push(this.nonStandardItemDescription)
      //this.push(FormBuilderControlListHelper.getListColumn("price", "Price", null, null, "price_formatted"));
      //var supplier = FormBuilderControlListHelper.getListColumn("supplier.name", "Supplier", null, null, "supplier_name_formatted");
      //supplier.visible = false;
      //this.push(supplier);
      //this.push(this.id)

      //this.isStandardItem.name = "Standard Item";

    } catch { }
  }
}


export class RequisitionItemList extends entity.RequisitionItemList {
  protected requisitionItemListEndPoints: RequisitionItemEndPoints = new RequisitionItemEndPoints();
  protected requisitionItemListColumns: RequisitionItemListColumns = new RequisitionItemListColumns();
  public tableIsGrouped: boolean = true;
  public rowCount?: any = 5000;
  public rowHeight: any = 50;
  public grandTotalField: string = 'price_excl';

  public groupingField: string = 'supplier_name_formatted';
  public groupingSubtotalCalcField: string = 'price_excl';
  public grandTotalFunc: any = function (items) {
    var total = 0;
    var excl = 0;
    items.forEach(o => {
      if (o["price_excl"])
        excl += o["price_excl"]
      if (o["price"])
        total += o["price"]
    });
    return "Grand Total - R " + total.toLocaleString() + " (R " + excl.toLocaleString() + " excl)";
  };
  public groupingSubtotalCalcFunc: any = function (items) {
    var total = 0;
    var excl = 0;
    items.forEach(o => {
      if (o["price_excl"])
        excl += o["price_excl"]
      if (o["price"])
        total += o["price"]
    });
    return "R " + total.toLocaleString() + " (R " + excl.toLocaleString() + " excl)";
  };
  public autoExpandRows: boolean = true;
  public rowGroupMetadataActions: any = [
    {
      icon: "check", tooltip: "Request approval",
      visible: function (context) {
        if (!context.authService)
          return false;
        return context.authService.hasAnyPermissions(Permissions.ProcurementApproval)
      },
      click: function (evt, context, itemsInGroup) {
        context.loading = true;
        context.apiService.post(`/api/requisitionItem/createWorkflows/${WorkflowType.WorkflowItemApprovalRequested}`, {
          reqItemIds: itemsInGroup.map(o => {
            return o.id
          })
        })
          .subscribe(o => {
            context.loading = false;
            context.messageService.success('Save successfully', 'Action');
            context.reloadTable()
          }, err => {
            context.loading = false;
            context.messageService.danger('Could not save', 'Action');
          }) 
      }
    },
    {
      icon: "check-double", tooltip: "Approve",
      visible: function (context) {
        if (!context.authService)
          return false;
        return context.authService.hasAnyPermissions(Permissions.RequisitionApproval)
      },
      click: function (evt, context, itemsInGroup) {
        context.loading = true;
        context.apiService.post(`/api/requisitionItem/createWorkflows/${WorkflowType.WorkflowItemApproved}`, {
          reqItemIds: itemsInGroup.map(o => {
            return o.id
          })
        })
          .subscribe(o => {
            context.loading = false;
            context.messageService.success('Saved successfully', 'Action');
            context.reloadTable()
          }, err => {
            context.loading = false;
            context.messageService.danger('Could not save', 'Action');
          })
      }
    },
    {
      icon: "ban", tooltip: "Do not request approval",
      visible: function (context) {
        if (!context.authService)
          return false;
        return context.authService.hasAnyPermissions(Permissions.ProcurementApproval)
      },
      click: function (evt, context, itemsInGroup) {
        context.loading = true;
        context.apiService.post(`/api/requisitionItem/createWorkflows/${WorkflowType.WorkflowItemPending}`, {
          reqItemIds: itemsInGroup.map(o => {
            return o.id
          })
        })
          .subscribe(o => {
            context.loading = false;
            context.messageService.success('Saved successfully', 'Action');
            context.reloadTable()
          }, err => {
            context.loading = false;
            context.messageService.danger('Could not save', 'Action');
          })
      }
    },
    {
      icon: "ban", tooltip: "Unapprove",
      visible: function (context) {
        if (!context.authService)
          return false;
        return context.authService.hasAnyPermissions(Permissions.RequisitionApproval)
      },
      click: function (evt, context, itemsInGroup) {
        context.loading = true;
        context.apiService.post(`/api/requisitionItem/createWorkflows/${WorkflowType.WorkflowItemApprovalRequested}`, {
          reqItemIds: itemsInGroup.map(o => {
            return o.id
          })
        })
          .subscribe(o => {
            context.loading = false;
            context.messageService.success('Saved successfully', 'Action');
            context.reloadTable()
          }, err => {
            context.loading = false;
            context.messageService.danger('Could not save', 'Action');
          })
      }
    }
  ]


}


export class RequisitionItemDetailReportEndPoints extends RequisitionItemEndPoints {
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/detailedReport" }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/detailedReportCount" }, method: "POST" };
}
export class RequisitionItemDetailReportListColumns extends entity.RequisitionItemListColumns {
  constructor() {
    super();
    try {
      if (this["id"]) this["id"].visible = false;
      if (this["changedById"]) this.splice(this.indexOf(this["changedById"]), 1)
      if (this["datestamp"]) this.splice(this.indexOf(this["datestamp"]), 1)
      this.splice(0, this.length);
      var supplier = FormBuilderControlListHelper.getListColumn("supplier.name", "Supplier", null, null, "supplier_name_formatted");
      var warehouse = FormBuilderControlListHelper.getListColumn("warehouse.name", "Supplier", null, null, "supplier_name_formatted");
      warehouse.visible = false;
      this.push(warehouse);
      this.push(supplier);
      this.push(FormBuilderControlListHelper.getListColumn("requisition.uniqueId", "Req Number", null, null, "requisition_uniqueId"));
      this.push(FormBuilderControlListHelper.getListColumn("requisitionPartial.sisproIdentifier", "PO", null, null, "requisitionPartial_sisproIdentifier"));
      this.push(FormBuilderControlListHelper.getListColumn("requisition.latestRequisitionWorkflow.workflow.name", "Current Workflow", null, null, "requisition_latestRequisitionWorkflow_workflow_name"));

      var job = FormBuilderControlListHelper.getListColumn("projectJobNumber.sysproJobNo", "Job", null, null, "projectJobNumber_sysproJobNo");
      var ledger = FormBuilderControlListHelper.getListColumn("generalLedger.code", "Ledger", null, null, "generalLedger_code");
      job.width = 70;
      ledger.width = 70;
      this.push(job);
      this.push(ledger);
      this.nonStandardItemDescription.name = "Item Description";
      this.projectJobNumberId.visible = false;
      this.datestamp.visible = false;
      this.jobSpecific.visible = false;
      this.push(this.datestamp);
      this.push(this.projectJobNumberId);
      this.push(this.jobSpecific);
      this.push(this.hierarchyId);
      this.hierarchyId.visible = false;
      this.push(this.generalLedgerId);
      this.push(this.warehouseId);
      this.warehouseId.visible = false;
      this.generalLedgerId.visible = false;

      this.push(FormBuilderControlListHelper.getListColumn("latestRequisitionItemWorkflow.workflow.name", "Workflow", null, null, "latestRequisitionItemWorkflow_workflow_name"));


      var workflowId = FormBuilderControlListHelper.getListColumn("latestRequisitionItemWorkflow.workflowId", "Workflow", null, null, "latestRequisitionItemWorkflow_workflowId");
      workflowId.visible = false;
      this.push(workflowId);
      this.isStandardItem.readOnly = false;
      this.inStock.viewType = ViewType.CheckBox;
      this.inStock.readOnly = function (data, auth) {
        if (!auth || !data)
          return true;
        return true;
      };


      this.push(this.nonStandardItemDescription)
      this.push(this.qty);
      this.push(this.unitPrice);
      this.unitPrice.template = function (t) {
        return typeof t == 'undefined' ? '' : "R " + t.toLocaleString()
      }
      this.push(this.price);
      this.price.template = function (t, e) {
        debugger
        return typeof t == 'undefined' ? '' : "R " + t.toLocaleString()
      }

      this.qty.width = 70;
      this.inStock.width = 70;
      //supplier.visible = false;
      this.push(this.id)

      this.push(this.taxable);
      this.push(this.supplierId);
      this.supplierId.visible = false;
      this.isStandardItem.name = "Standard Item";

    } catch { }
  }
}
export class RequisitionItemDetailReportList extends entity.RequisitionItemList {
  protected requisitionItemListEndPoints: RequisitionItemDetailReportEndPoints = new RequisitionItemDetailReportEndPoints();
  protected requisitionItemListColumns: RequisitionItemDetailReportListColumns = new RequisitionItemDetailReportListColumns();
  public disableNavigation: boolean = true;
}

export class RequisitionItemReportEndPoints implements IEntityEndPoints {
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/lazyOutstanding/" }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (): string { return app.config.controllerRouteRoot + "/requisitionItem/lazyOutstandingCount/" }, method: "POST" };
}
export class RequisitionItemReportList extends entity.RequisitionItemList {
  protected requisitionItemListEndPoints: RequisitionItemReportEndPoints = new RequisitionItemReportEndPoints();
  protected requisitionItemListColumns: RequisitionItemReportListColumns = new RequisitionItemReportListColumns();
  public disableNavigation: boolean = true;

  public relatedModels: Array<IEntityModel> = [new ReqItem(), new RequisitionPartialDTO(), new SupplierDTO(), new StockItemDTO()]
}



export class RequisitionItemReportOutstandingItemsListBladeSetup {
  public menuActions: Array<IDetailComponent> = [
    {
      index: 0, displayName: "Export Selected", click: function (context) {
        var table = context.getFormInstanceByIndex(0).lazyTable;
        let filterArr = new Array();


        if (table.staticFilters)
          table.staticFilters.filter(function (o) {
            return o.filterValue != '' && o.filterValue != null
          })
            .forEach(o => {
              filterArr.push({ columnName: o.columnName, filterValue: o.filterValue, whereFilterType: o.whereFilterType });
            });
        let filterObject = JSON.parse(table._currentFilterObject);
        filterObject.StartCount = 0;
        filterObject.PageSize = 9999999;
        filterObject.FriendlyCols = table.selectedVisibleColumns.map(o => ({ value: o.dbField, key: o.name }))

        var download: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/requisitionItem/lazyExport" }, method: "POST" };
        var self = context;


        self.apiService.exec({
          data: filterObject,
          endPoint: download,
          context: self,
          success: function (data) {
            const link = document.createElement('a');
            link.href = `${appSettings.apiServiceAddress}/api/fileServe/report/${data.name}`;
            link.setAttribute('visibility', 'hidden');
            link.click();
          },
          error: function (error) {
            self.loading = false;
            self.messageService.danger('Could not Export', 'Action');
          }
        })
      }
    },
  ]
}

export class RequisitionItemReportOutstandingItemsList extends entity.RequisitionItemList {
  protected requisitionItemListEndPoints: RequisitionItemReportEndPoints = new RequisitionItemReportEndPoints();
  protected requisitionItemListColumns: RequisitionItemReportListColumns = new RequisitionItemReportListColumns();
  public disableNavigation: boolean = true;
  public init: any = function (context) {
    var _th = this;
    if (context.authService && context.authService.userProfile)
      _th.addStaticFilters(context);
    else
      context.authService.userProfileObserver.subscribe(o => {
        _th.addStaticFilters(context);
      });

  }

  addStaticFilters = function (context) {
    context.staticFilters = new Array();

    var actionRequired = FormBuilderControlListHelper.getListColumn("", "", ViewType.Dropdown, null, "reportType");
    actionRequired.formBuilderControl.lookups = [
      { label: "Outstanding Items", value: "Outstanding" },
      { label: "Received Items", value: "Received" },
      { label: "All Items", value: "All" },
    ]
    //actionRequired.default = "Outstanding";
    actionRequired.width = 130;

    context.staticFilters.push({ control: actionRequired.formBuilderControl, filterValue: 'Outstanding', whereFilterType: 1, columnName: "reportType" });
    context.showAdvancedFilters = true;

  }
  public relatedModels: Array<IEntityModel> = [new ReqItem(), new RequisitionPartialDTO(), new SupplierDTO(), new StockItemDTO()]

}




export class ReqItem extends RequisitionItemDTO {
  public excludeModelPrefix: boolean = true;
}

export class PartialRequisitionItemList extends entity.RequisitionItemList {
  protected requisitionItemListEndPoints: PartialRequisitionItemEndPoints = new PartialRequisitionItemEndPoints();
  protected requisitionItemListColumns: RequisitionItemListColumns = new RequisitionItemListColumns();
  public rowCount?: any = 5000;
  public grandTotalField: string = 'price_excl';
  public tableIsGrouped: boolean = true;
  public groupingField: string = 'supplier_name_formatted';
  public groupingSubtotalCalcField: string = 'price_excl';
  public autoExpandRows: boolean = true;
  public grandTotalFunc: any = function (items) {
    var total = 0;
    var excl = 0;
    items.forEach(o => {
      if (o["price_excl"])
        excl += o["price_excl"]
      if (o["price"])
        total += o["price"]
    });
    return "Grand Total - R " + total.toLocaleString() + " (R " + excl.toLocaleString() + " excl)";
  };
  public groupingSubtotalCalcFunc: any = function (items) {
    var total = 0;
    var excl = 0;
    items.forEach(o => {
      if (o["price_excl"])
        excl += o["price_excl"]
      if (o["price"])
        total += o["price"]
    });
    return "R " + total.toLocaleString() + " (R " + excl.toLocaleString() + " excl)";
  };
}

export class RequisitionItemMyItemsList extends entity.RequisitionItemList {
  protected requisitionItemListEndPoints: RequisitionItemMyListEndPoints = new RequisitionItemMyListEndPoints();
  protected requisitionItemListColumns: RequisitionMyItemListColumns = new RequisitionMyItemListColumns();
  public rowCount?: any = 5000;
}

export class RequisitionItemProcessedItemsList extends entity.RequisitionItemList {
  protected requisitionItemListEndPoints: RequisitionItemMyListEndPoints = new RequisitionItemMyListEndPoints();
  protected requisitionItemListColumns: RequisitionItemListColumns = new RequisitionItemListColumns();
  public rowCount?: any = 5000;
}

export class RequisitionItemSupplierExpendListEndPoints extends entity.RequisitionItemEndPoints {
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/reqDashboard/expendPerSupplier" }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/reqDashboard/expendPerSupplierCount" }, method: "POST" };

}
export class RequisitionItemExpendListColumns extends entity.RequisitionItemListColumns {
  constructor() {
    super();
    try {
      this.splice(0, this.length);
      this.push(FormBuilderControlListHelper.getListColumn("id", "Key", null, null, "key"))
      this.push(FormBuilderControlListHelper.getListColumn("id", "Amount", null, null, "amount"))
    } catch { }
  }
}
export class RequisitionItemGraphExpendListColumns extends entity.RequisitionItemList {
  protected requisitionItemListEndPoints: RequisitionItemSupplierExpendListEndPoints = new RequisitionItemSupplierExpendListEndPoints();
  protected requisitionItemListColumns: RequisitionItemExpendListColumns = new RequisitionItemExpendListColumns();
  public relatedModels: Array<IEntityModel> = [new ReqItem(), new RequisitionPartialDTO(), new SupplierDTO(), new StockItemDTO()]

}

export class RequisitionItemSupplierExpendPerJobListEndPoints extends entity.RequisitionItemEndPoints {
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/reqDashboard/expendPerJob" }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/reqDashboard/expendPerJobCount" }, method: "POST" };

}
export class RequisitionItemGraphExpendPerJobListColumns extends entity.RequisitionItemList {
  protected requisitionItemListEndPoints: RequisitionItemSupplierExpendPerJobListEndPoints = new RequisitionItemSupplierExpendPerJobListEndPoints();
  protected requisitionItemListColumns: RequisitionItemExpendListColumns = new RequisitionItemExpendListColumns();
  public relatedModels: Array<IEntityModel> = [new ReqItem(), new RequisitionPartialDTO(), new SupplierDTO(), new StockItemDTO()]

}

export class RequisitionItemSupplierPerBuyerExpendListEndPoints extends entity.RequisitionItemEndPoints {
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/reqDashboard/expendPerBuyer" }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/reqDashboard/expendPerBuyerCount" }, method: "POST" };

}
export class RequisitionItemGraphExpendPerBuyerListColumns extends entity.RequisitionItemList {
  protected requisitionItemListEndPoints: RequisitionItemSupplierPerBuyerExpendListEndPoints = new RequisitionItemSupplierPerBuyerExpendListEndPoints();
  protected requisitionItemListColumns: RequisitionItemExpendListColumns = new RequisitionItemExpendListColumns();
  public relatedModels: Array<IEntityModel> = [new ReqItem(), new RequisitionPartialDTO(), new SupplierDTO(), new StockItemDTO()]

}

export class RequisitionItemSupplierPerTimeExpendListEndPoints extends entity.RequisitionItemEndPoints {
  search?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/reqDashboard/expendPerTime" }, method: "POST" };
  pagingTotalCount?: IDataEndPoint = { url: function (serviceCommand: IApiServiceCommand): string { return app.config.controllerRouteRoot + "/reqDashboard/expendPerTimeCount" }, method: "POST" };

}
export class RequisitionItemGraphExpendPerTimeListColumns extends entity.RequisitionItemList {
  protected requisitionItemListEndPoints: RequisitionItemSupplierPerTimeExpendListEndPoints = new RequisitionItemSupplierPerTimeExpendListEndPoints();
  protected requisitionItemListColumns: RequisitionItemExpendListColumns = new RequisitionItemExpendListColumns();
  public relatedModels: Array<IEntityModel> = [new ReqItem(), new RequisitionPartialDTO(), new SupplierDTO(), new StockItemDTO()]

}



